<div class="inset-0 relative md:sticky md:top-[100px]">
	<fb-filter-active-controls (onControlsChange)="onFilterControlChange()"
							   [showClearFilterButton]="showClearFilterButton"
							   [selectedFilters]="selectedFilters"
							   [controls]="controls"></fb-filter-active-controls>
	<button *ngIf="result.length"
			class="w-full rounded text-[#8E7862] py-1 px-3 bg-[#fffcf7]
						transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm mb-2  mr-3">
		Showing <span class="font-medium">{{ result.length }}</span> Products
	</button>
	<ng-container *ngIf="inStockControl.key.type === 'toggle'">
		<div class="mb-4">
			<fb-filter-toggle-control [control]="inStockControl"
									  (onControlChange)="onFilterControlChange()"></fb-filter-toggle-control>
		</div>
	</ng-container>
	<section class="fb-filter-container flex flex-col justify-start items-stretch h-screen overflow-y-auto">
		<fb-filter-control *ngFor="let control of controls.cohorts; let i = index;"
						   [control]="control"
						   (onControlChange)="onFilterControlChange()"></fb-filter-control>
	</section>
</div>
